module.exports = __webpack_public_path__ + "static/media/tick-circle-blue.96022099.svg";